var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFootnote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "superscript_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#484848}\n        "))), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_19896",
    "data-name": "Rectangle 19896",
    style: {
      fill: "none"
    },
    d: "M0 0h20v20H0z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21934",
    "data-name": "Group 21934",
    transform: "translate(.833 3.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17786",
    "data-name": "Path 17786",
    className: "cls-2",
    d: "M5.88 14.374h1.591L9.5 11.132h.072l2.034 3.242H13.2l-2.78-4.348L13.016 6h-1.6L9.577 8.985H9.5L7.657 6H6.065l2.585 4.026z",
    transform: "translate(-5.88 -1.041)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17803",
    "data-name": "Path 17803",
    className: "cls-2",
    d: "M5.88 14.374h1.591L9.5 11.132h.072l2.034 3.242H13.2l-2.78-4.348L13.016 6h-1.6L9.577 8.985H9.5L7.657 6H6.065l2.585 4.026z",
    transform: "translate(1.298 -1.041)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17802",
    "data-name": "Path 17802",
    className: "cls-2",
    d: "M21.5 6.5h-1.667v.833h2.5v.833H19V6.5a.836.836 0 0 1 .833-.833H21.5v-.834H19V4h2.5a.836.836 0 0 1 .833.833v.833a.836.836 0 0 1-.833.834z",
    transform: "translate(-4.733 -4)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootnote);
export default __webpack_public_path__ + "static/media/footnote.b7c0de3552987ddbc65231290404496b.svg";
export { ForwardRef as ReactComponent };